import { createBlueprint as t } from "@made-people/blueprint";
const r = t({
  slots: {
    wrapper: "",
    currency: "",
    label: ""
  },
  variants: {}
}), s = t({
  slots: {
    formWrapper: "p-4 flex flex-col gap-4 items-center w-[80vw] lg:w-[25vw] max-w-[500px]"
  },
  variants: {}
}), n = t({
  slots: {
    contentWrapper: "flex flex-col gap-4 items-center"
  },
  variants: {}
}), i = t({
  slots: {
    base: ""
  },
  variants: {}
});
export {
  r as currencyDisplayBlueprint,
  n as siteSettingsDrawerBlueprint,
  s as siteSettingsFormBlueprint,
  i as siteSettingsTriggerBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
